import { errorMessageUpgradeToPremium, errorMessageVerify } from './wasclUtils.locstring.json';
import loc from 'owa-localize';
import { ComposeViewState } from 'owa-mail-compose-store';

import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import removeInfoBarMessage from '../actions/removeInfoBarMessage';
import trySaveMessage from '../actions/trySaveMessage';
import { HipCheckModal } from 'owa-mail-hip-check-modal';
import { InfoBarCustomAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { isFeatureEnabled } from 'owa-feature-flags';
import { showModal } from 'owa-modal';

let upgradeToPremiumUrl = '';
let accountRecoveryFlowUrl = '';
const hipControlUrl = '/owa/owahipcontrol.aspx?compose=1';

export function preHandleErrorResponse(response: any, viewState: ComposeViewState) {
    if (response) {
        if (response.WasclUpgradeToPremiumUrl) {
            upgradeToPremiumUrl = response.WasclUpgradeToPremiumUrl;
        }

        if (response.AccountRecoveryFlowUrl) {
            accountRecoveryFlowUrl = response.AccountRecoveryFlowUrl;
        }

        const responseMessage =
            response.ResponseMessages && response.ResponseMessages.Items
                ? (response.ResponseMessages.Items[0] as ItemInfoResponseMessage)
                : null;
        if (
            responseMessage &&
            (responseMessage.ResponseCode == 'ErrorExceededMessageLimit' ||
                responseMessage.ResponseCode == 'ErrorExceededHourlyMessageLimit' ||
                responseMessage.ResponseCode == 'ErrorExceededMessageLimitShowTierUpgrade')
        ) {
            trySaveMessage(viewState, true /*isAutoSave*/);
        }
    }
}

export function getUpgradeToPremiumButton(viewState: ComposeViewState): InfoBarCustomAction {
    return {
        text: loc(errorMessageUpgradeToPremium),
        action: () => {
            removeInfoBarMessage(viewState, [
                'errorMessageExceededMessageLimit',
                'errorMessageExceededMaxRecipientLimit',
            ]);
            window.open(upgradeToPremiumUrl);
        },
    };
}

let showModalPromise: Promise<{ success: boolean }> = null;
function removeHipCheckInfoBars(viewState: ComposeViewState) {
    removeInfoBarMessage(viewState, [
        'errorMessageMessageSubmissionBlocked',
        'errorMessageExceededMaxRecipientLimitShowTierUpgrade',
        'errorMessageExceededMessageLimitShowTierUpgrade',
    ]);
}

export function getHipVerifyButton(viewState: ComposeViewState): InfoBarCustomAction {
    return {
        text: loc(errorMessageVerify),
        action: () => {
            if (isFeatureEnabled('cmp-hipCheckModal')) {
                if (showModalPromise !== null) {
                    // only spawn one modal at a time;
                    return;
                }

                [showModalPromise] = showModal(HipCheckModal);
                showModalPromise.then(
                    ({ success }: { success: boolean }) => {
                        showModalPromise = null;
                        if (success) {
                            removeHipCheckInfoBars(viewState);
                        }
                    },
                    err => {
                        showModalPromise = null;
                    }
                );
            } else {
                removeHipCheckInfoBars(viewState);
                window.open(hipControlUrl);
            }
        },
    };
}

export function getAccountRecoveryFlowButton(viewState: ComposeViewState): InfoBarCustomAction {
    return {
        text: loc(errorMessageVerify),
        action: () => {
            removeInfoBarMessage(viewState, [
                'errorMessageAccountSuspend',
                'errorMessageAccountSuspendShowTierUpgrade',
            ]);
            window.open(accountRecoveryFlowUrl);
        },
    };
}
